import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Route changes start at the top of the new view. In-page anchors (#work) are
// left alone so the single smooth-scroll target still works.
const ScrollToTop = () => {
	const { pathname, hash } = useLocation();

	useEffect(() => {
		if (hash) return;
		window.scrollTo(0, 0);
	}, [pathname, hash]);

	return null;
};

export default ScrollToTop;
